module cr.entity
{
    export class TreeManager implements ITreeNode,ITreeManager {
        Action(actionName:string, args?:any) {
        }

        TreeManager:entity.ITreeManager;

        nodeType=()=>"Root";

        GetNodeReference(node:ITreeNode, reference?:Array<string>):Array<string> {
            if (reference == null) reference = [];
            if (node == this) return reference;
            reference.unshift(node.id);
            return this.GetNodeReference(node.parent, reference);
        }

        SearchNode(reference:Array<string>):ITreeNode {

            var toRet:ITreeNode = this;

            var i = 0;
            while (i < reference.length) {
                toRet = _.find(this.nodes, (n:ITreeNode)=> {
                    return n.id == reference[i]
                });
                if (toRet == null) return null;
                i++;
            }

            return toRet;
        }

        currentNode:ITreeNode;
        currentPlugin:string;
        currentPluginSettings:any;
        contentRef:number=0;

        SetContent(plugin:string, sourceNode?:entity.ITreeNode, settings?:any) {
            this.currentPlugin = plugin;
            this.contentRef++;
            if (angular.isDefined(sourceNode)) this.currentNode = sourceNode;
            if (angular.isDefined(settings)) this.currentPluginSettings = settings;

        }

        id:string;
        collapsed:boolean;
        displayName(){ return "Root"; }
        parent:entity.ITreeNode;

        public nodes:Array<ITreeNode>;

        NodeAction(treeScope:any, actionName:string) {
            console.log("Action: " + actionName);
            var treeNode = <ITreeNode>treeScope.$modelValue;
            treeNode.Action(actionName);
        }

        AdjustNodes(current:ITreeNode, parent?:ITreeNode) {
            current.TreeManager = this;
            current.parent = parent ? parent : this;
            angular.forEach(current.nodes, (node)=>this.AdjustNodes(node, current));
        }

        AddNode(toAdd:ITreeNode, parent?:ITreeNode) {
            this.AdjustNodes(toAdd, parent);

            if (parent == null) {
                this.nodes.push(toAdd);
            } else {
                parent.nodes.push(toAdd);
            }
        }

        constructor(private $state:any, private $q: angular.IQService) {
            this.nodes = [];
        }
    }

}
